module.exports = __webpack_public_path__ + "static/media/no_position.035c7c64.svg";